export const offlineStores = {
  Checklist: 'Checklist',
  Configuration: 'Configuration',
} as const;
